<template>
    <div class="home-footer">
        <!-- <div class="links">
            <ul class="list">
                <li class="item" v-for="(item, idx) in linksList" :key="idx">
                    <a :href="item.lk" class="lk" target="_blank">{{
                        item.title
                    }}</a>
                </li>
            </ul>
        </div> -->

        <div class="footer">
            <div class="contact">
                <div class="c-item">版权所有:中国土木工程学会</div>
                <div class="c-item">地址:北京三里河路9号建设部内   邮编: 100835</div>
                <div class="c-item">Email: Master@cces.net.cn</div>
                <div class="c-item">京ICP备15056524号</div>
                <div class="c-item">技术支持:UCD轨道院数字中心</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PublicFooter",
    data() {
        return {
            logoUrl: require("@assets/img/logo-footer.png"),
            linksList: [
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
                { lk: "https://www.baidu.com", title: "友情链接" },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.home-footer {
    width: 100%;

    .links {
        width: 100%;
        padding: 30px 15px;
        background: #eee;

        .list {
            @include flex-start;
            flex-wrap: wrap;
            width: 1200px;
            margin: -15px auto 0;

            .item {
                width: 12.5%;
                margin-top: 15px;
                text-align: center;

                .lk {
                    color: $defaultColor;
                }
            }
        }
    }

    .footer {
        width: 100%;
        padding: 70px 0;
        background: #222;

        .contact {
            font-size: 16px;
            text-align: center;
            color: #c9caca;

            .c-item {
                line-height: 30px;
            }
        }

    }
}
</style>